'use strict';

module.exports = function () {
    $("button[data-micromodal-trigger='alert-out-of-stock']").click(function () {
        var labelAlertHTML = $('.out-of-stock-variant-label').val();
        var idAlertHTML = $('.out-of-stock-variant-id').val();
        setTimeout(function () {
            if ($('#alert-out-of-stock').hasClass('is-open')) {
                $('#variation-label-alert').html(labelAlertHTML);
                $('#alert-out-of-stock').closest(".alertProductId").val(idAlertHTML);
            }
        }, 100);
    });

    $('.alert-out-of-stock .create-alert-submit').click(function (e) {       
        e.preventDefault();
        var $error = $('.alert-out-of-stock  .invalid-feedback2');
        var $error2 = $('.alert-product-form  .form-control2');
        var $success = $('.alert-out-of-stock  .out-of-stock-success-message');
        var $closebtn = $('.alert-out-of-stock  .close');
        var $backinstockmessage = $('.alert-out-of-stock  .backinstock-alert');
        var $alertform = $('.create-alert .alert-product-form');
        var $buttonform = $('.create-alert .alert-product-stock-btn');
        
        // $error.hide();
        $error2.removeClass('is-invalid');
        $success.hide();
        
        var $form = $('.alert-out-of-stock .alert-product-form');
        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/; 

        var email = $('#alertProductEmail');

        $('.alert-product-form').removeClass('hidden');

        if (email.val().trim() !== '') {
            if (!filter.test(email.val())) {
                $error.removeClass('hidden');
                $error2.addClass('is-invalid');
                $error.show();
            } else {
                $.ajax({
                    url: $form.data('action'),
                    method: 'GET',
                    data: $form.serialize(),
                    success: function (data) {
                        $alertform.hide();
                        $backinstockmessage.hide();
                        $success.show();
                        setTimeout(function(){
                            $closebtn.trigger('click');
                            $alertform.show();
                            $backinstockmessage.show();
                            $success.hide();
                        }, 2000);
                        var pastSubmitedValue = $buttonform.attr('data-submited');
                        if(pastSubmitedValue){
                            $buttonform.attr('data-submited', pastSubmitedValue + '/' + data.gtm.products.id);
                        }else{
                            $buttonform.attr('data-submited', data.gtm.products.id);
                        }
                        $buttonform.prop('disabled', true);
                        
                        try {
                            //trigger gtm
                            if (data.gtm != null) {
                                dataLayer.push(data.gtm);
                            }
                        } catch (e) {
                            // TODO: handle exception
                            console.warn('Unable to trigger alert OOS GTM')
                        }
                    },
                    error: function () {
                    }
                });
            }
        } else if (email.val().trim() === '') {
            $error2.addClass('is-invalid');
        }
    });

    // Notified when product is no more sale.
    $('.alert-out-of-stock .create-alert-submit-nosale').click(function (e) {   
        e.preventDefault();
        var $error = $('.alert-out-of-stock  .invalid-feedback');
        var $error2 = $('.alert-product-form-nosale  .form-control2');
        var $success = $('.alert-out-of-stock  .out-of-stock-success-message');
        var $backinstockmessage = $('.alert-out-of-stock  .backinstock-alert');
        var $alertform = $('.create-alert .alert-product-form-nosale');
        var $buttonform = $('.create-alert .alert-product-stock-btn');
        var $btnSUBMIT = $('.btn-SUBMIT');
        var $iconCHECK = $('.icon-CHECK');
        
        $btnSUBMIT.removeClass('hidden');
        $iconCHECK.addClass('hidden');
        $error.hide();
        $error2.removeClass('is-invalid');
        $success.hide();
        
        var $form = $('.alert-out-of-stock .alert-product-form-nosale');
        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/; 
        var email = $('.alertProductEmail');

        $('.alert-product-form-nosale').removeClass('hidden');

        if (email.val().trim() !== '') {
            if (!filter.test(email.val())) {
                $error.removeClass('hidden');
                $error2.addClass('is-invalid');
                $error.show();
            } else {
                $.ajax({
                    url: $form.data('action'),
                    method: 'GET',
                    data: $form.serialize(),
                    success: function (data) {
                        $alertform.hide();
                        $backinstockmessage.hide();
                        $success.show();
                        $btnSUBMIT.addClass('hidden');
                        $iconCHECK.removeClass('hidden');
                        $success.removeClass('hidden');
                        $error.hide();
                        
                        var pastSubmitedValue = $buttonform.attr('data-submited');
                        if(pastSubmitedValue){
                            $buttonform.attr('data-submited', pastSubmitedValue + '/' + data.gtm.products.id);
                        }else{
                            $buttonform.attr('data-submited', data.gtm.products.id);
                        }
                        $buttonform.prop('disabled', true);
                        
                        try {
                            //trigger gtm
                            if (data.gtm != null) {
                                dataLayer.push(data.gtm);
                            }
                        } catch (e) {
                            // TODO: handle exception
                            console.warn('Unable to trigger alert OOS GTM')
                        }
                        
                    },
                    error: function () {
                    }
                });
            }
        } else if (email.val().trim() === '') {
            $error2.addClass('is-invalid');
            $error.show();
        }
    });
};
